import { useNotification } from '@/containers'
import Link from 'next/link'
import ImageOptimize from '../ImageOptimize'

interface HeaderLogoProps {
  type?: number
}

export const HeaderLogo = ({ type }: HeaderLogoProps) => {
  const { systemConfig } = useNotification()

  return (
    <Link className='block h-full' href='/'>
      {type === 1 && systemConfig?.companyLogoHeader ? (
        <ImageOptimize
          quality={100}
          className='h-full w-auto max-w-[200px] object-contain object-left'
          alt={systemConfig?.websiteBrandName || ''}
          src={systemConfig?.companyLogoHeader || ''}
          priority={true}
          loading='eager'
        />
      ) : (
        systemConfig?.companyLogo && (
          <ImageOptimize
            quality={100}
            className='h-full w-auto max-w-[200px] object-contain'
            alt={systemConfig?.websiteBrandName || ''}
            src={systemConfig?.companyLogo || ''}
            priority={true}
            loading='eager'
          />
        )
      )}
    </Link>
  )
}
